module.exports = __webpack_public_path__ + "img/27.35a6ff53.jpg";